import { Box, Button, Container, CssBaseline, TextField, Typography } from "@mui/material"
import React, { useCallback, useEffect, useState } from "react"
import { useNavigate, useNavigation } from "react-router-dom";
import { useAppState } from "../../contexts/appState";
import apis, { initApis } from "../../common/apis";
import { T_user } from "../../common/model/user";

function SignIn(){

    const navigator = useNavigate();

    const {appState,setAppState} = useAppState();
    const [userId, setUserId] = useState("");
    const [userPassword, setUserPassword] = useState("");

    


    const getLogin = useCallback(async () => {
        try {
          const result = await apis.user.loginPw({
            userId:userId,
            userPw : userPassword
          });
            console.log("Login:",result)
                if(result.code == "1"){
                  await setAppState({user:result.data as T_user});
                }else{
                  alert("아이디나 패스워드에 맞지 않습니다.");
                }
           } catch (err: any) {
            alert("로그인중 에러가 발생하였습니다.");
        }
      }, [userId,userPassword]);

      
     useEffect(()=>{
//       console.log("appState Login Page:",appState);
//         if(appState.user != null ){
//           console.log("appState user exist")
//    //       console.log(appState.user);
//             loginAccessToken(appState.user).then(()=>{
//                 navigator("/")
//             });
//         }else{
//           console.log("no exist")
//         }
     },[]) 

  // 2) 이미 로그인된 상태면 바로 홈으로
  useEffect(() => {
    console.log("Login Check:",appState)
    if (appState.user) {
      navigator('/', { replace: true })
    }
  }, [appState.user, navigator])

    return(
        <Container maxWidth="sm" style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
     <Box
      sx={{
        display: 'flex',
        flexDirection:'column',
        justifyContent: 'center',
        alignItems: 'center',
        background:"white",
        height: '100vh', // 100% 화면 높이
      }}
    >
         <Typography
     variant="h4" // 텍스트 크기를 크게 지정
     component="h3" // 텍스트가 제목처럼 보이도록 설정
    
     sx={{
        paddingBottom:3,
       color: 'grey', // 텍스트 색상 설정
       justifyContent:'center'
       ,textAlign:'center'
     }}
     ></Typography>
      <Box
        sx={{
          borderTop: '3px solid black', 
          borderLeft:'1px solid grey',
          borderBottom:'1px solid grey',
          borderRight:'1px solid grey',
          color: 'white',
          lineHeight: '100px',
          padding:2,
        }}
      >
     <Typography
     variant="h4" // 텍스트 크기를 크게 지정
     component="h4" // 텍스트가 제목처럼 보이도록 설정
     sx={{
       color: 'black', // 텍스트 색상 설정
       justifyContent:'center'
       ,textAlign:'center'
     }}
     >LOGIN</Typography>
     <Typography
     variant="subtitle1" // 텍스트 크기를 크게 지정
     component="h6" // 텍스트가 제목처럼 보이도록 설정
     sx={{
        paddingTop:1,
        paddingLeft:5,
        paddingRight:5,
        color: 'black', // 텍스트 색상 설정
     }}
     >로그인 하시면 A/S 정보를 <br/>관리하실수 있습니다. </Typography>     
        <Box
        sx={{width:'100%',marginTop:1,justifyContent:"flex-start"
            ,textAlign:"flex-start"
            }}
        >
        <Typography
     variant="h6" // 텍스트 크기를 크게 지정
     component="h6" // 텍스트가 제목처럼 보이도록 설정
     sx={{
        color: 'black' // 텍스트 색상 설정
        ,textAlign:'center'
        ,paddingBottom:2
     }}
     >회원로그인</Typography>  
 <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '100%' }}>
z
               <input
                           name="board_title"
                           placeholder="아이디"
                           style={{
                              width: '100%',
                              height:40,
                              borderRadius:0,
                              background:"#eeeeee",
                              borderWidth:1,
                              borderColor:"#cccccc",
                           }}
                           value={userId}
                           onChange={(event)=>{
                            setUserId(event.target.value);
                           }}
        />      

                          <input
                            type="password"
                           name="board_title"
                           placeholder="비밀번호"
                           style={{
                              width: '100%',
                              borderWidth:1,
                              height:40,
                              borderRadius:0,
                              background:"#eeeeee",
                              borderColor:"#cccccc",
                           }}
                           value={userPassword}
                           onChange={(event)=>{
                            setUserPassword(event.target.value);
                           }}
                />      

            <Button
                style={{marginBottom:10,marginTop:10}}
                 color="secondary"
                fullWidth={false}
                  variant="contained"
                  onClick={()=>{
                    getLogin();
                  }}
                >
                    로그인
            </Button>

           
    </div>
 
    </Box>
    </Box>
    </Box>
        </Container>
    )

}

export default SignIn;